/**
 * Shared validation/normalisation for the free-text criteria fields in the search
 * modals ("Search by Patient" and "Search by User / Employee"). Both modals apply the same rule:
 * a blank field is simply not part of the query, and a populated one has to be long enough to be
 * a meaningful prefix match against the API.
 */

/** Minimum characters required for a criteria field before it can be searched on. */
export const MIN_FIELD_LENGTH = 3;

/**
 * An error message when `value` is populated but shorter than {@link MIN_FIELD_LENGTH}; otherwise
 * null. A blank field is valid — it is omitted from the query rather than rejected.
 */
export function minLengthError(value: string, label: string): string | null {
  const trimmed = value.trim();
  if (trimmed.length === 0 || trimmed.length >= MIN_FIELD_LENGTH) {
    return null;
  }
  return `${label} must be at least ${MIN_FIELD_LENGTH} characters.`;
}

/** Trim a criteria field for the request, collapsing a blank one to null ("not filtered"). */
export function normalizeCriteria(value: string): string | null {
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}
